import { MDText } from 'i18n-react';

import { Hyperlink } from '@motorway/mw-highway-code/src/components/Hyperlink/Hyperlink';

import LocalTexts from '../../../../ulezTextV2.json';

import styles from './Disclaimer.scss';

const LocalT = new MDText(LocalTexts);

export const getDisclaimerLink = () => (
  <span className={styles.noWrap}>
    <Hyperlink
      data-thc-hyperlink-disclaimer
      as='a'
      href="https://tfl.gov.uk/modes/driving/check-your-vehicle"
      label={LocalT.translate('results.complianceDisclaimer.tflLink')}
      size='small'
      target="_blank" />
  </span>
);

export const Disclaimer = () => (
  <p className={styles.complianceDisclaimer}>
    {LocalT.translate('results.complianceDisclaimer.description', {
      link: getDisclaimerLink(),
    })}
  </p>
);
